import { useIsMobile } from "../../../redux/features/device/selectors";
import Skeleton from "react-loading-skeleton";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

const EarnPointsContent = ({
  activeCompetitions,
  activeCompetitionsLoading,
  showAllCompetitions,
  COLORS,
  setPointsByCompetitionType,
  onCompetitionClick,
}) => {
  const splitIntoGroupsOfSix = () => {
    const groups = [];
    for (let i = 0; i < activeCompetitions.length; i += 6) {
      groups.push(activeCompetitions.slice(i, i + 6));
    }
    return groups;
  };
  const isMobile = useIsMobile();
  if (activeCompetitionsLoading) {
    return <Skeleton highlightColor="#fff" count={1} inline height={300} containerClassName={"grid grid-cols-1"} />;
  }
  if (activeCompetitions.length > 0) {
    if (!isMobile) {
      return activeCompetitions.slice(0, showAllCompetitions ? activeCompetitions.length : 6).map((item: any) => {
        return (
          <>
            <div
              className={
                "flex items-center max-lg:w-full max-lg:my-2 first:max-lg:mt-0 last:max-lg:mb-0 px-2 lg:px-0 py-3 lg:pt-3 lg:pb-4 border-b border-black/8"
              }>
              <div className={"mr-3 rounded shrink-0"}>
                <img
                  src={item.CompetitionThumbnailPicture}
                  alt={"Placeholder"}
                  width={48}
                  height={48}
                  className="object-cover size-11 rounded lg:size-14"
                />
              </div>
              <div>
                <div
                  className={`text-sm lg:text-base leading-5 lg:leading-5.5 font-medium mb-1 lg:mb-2 ${COLORS[item.NavigationColour as keyof typeof COLORS]?.title}`}>
                  {item.Title} {item.AdditionalCashText ? item.AdditionalCashText : null}
                </div>
                <div className={`flex gap-1 ${item.Reference.includes("DC") ? "items-start" : "items-center"}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    className={"size-5"}>
                    <path
                      d="M17.3333 4.78933V1.33333C17.3333 0.596667 16.7367 0 16 0H1.33333C0.596667 0 0 0.596667 0 1.33333V4.78933C0.775333 5.06467 1.33333 5.79733 1.33333 6.66667C1.33333 7.536 0.775333 8.26867 0 8.544V12C0 12.7367 0.596667 13.3333 1.33333 13.3333H16C16.7367 13.3333 17.3333 12.7367 17.3333 12V8.544C16.558 8.26867 16 7.536 16 6.66667C16 5.79733 16.558 5.06467 17.3333 4.78933ZM12.368 5.974L10.4333 7.414L11.152 9.716C11.2487 10.0247 10.898 10.2793 10.634 10.092L8.66667 8.69733L6.69933 10.092C6.43533 10.2793 6.08533 10.0247 6.18133 9.716L6.9 7.414L4.96533 5.974C4.706 5.78133 4.84 5.36933 5.16333 5.36533L7.57467 5.33733L8.34667 3.05267C8.45 2.74667 8.88333 2.74667 8.98667 3.05267L9.75867 5.33733L12.17 5.36533C12.4933 5.36867 12.6273 5.78067 12.368 5.974Z"
                      fill="#898994"
                    />
                  </svg>
                  <div className={"flex flex-col"}>
                    <div className={"text-xs leading-4 lg:text-sm lg:leading-5 font-medium"}>
                      <strong className={"text-dark-1"}>{item.Points}</strong> draw tickets
                    </div>
                    {item.Reference.includes("DC") && (
                      <div
                        className={
                          "text-[#898994] font-jost text-[10px] lg:text-xs leading-3 lg:leading-4 font-medium"
                        }>
                        + extra draw tickets for add-ons
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                onClick={() => onCompetitionClick(item)}
                className={
                  "cursor-pointer uppercase bg-[#EEEEEF] ml-auto text-center px-2.5 py-1 rounded-lg text-nav-azure font-jost text-xs font-medium leading-normal min-h-8 lg:min-h-10 lg:min-w-20 flex-center lg:text-sm lg:leading-5"
                }>
                Enter
              </div>
            </div>
          </>
        );
      });
    } else {
      const groups = splitIntoGroupsOfSix();
      const hasMultipleSlides = groups.length > 1;

      return (
        <Swiper
          slidesPerView="auto"
          spaceBetween={isMobile ? 12 : "auto"}
          className={`!-mx-3 mb-4 !overflow-visible xmasDraws ${hasMultipleSlides ? "" : "[&_.bullet-bg]:!bg-[#DCDCDE] [&_.bullet-bg]:!border-0"}`}
          pagination={
            isMobile
              ? {
                  enabled: isMobile,
                  clickable: hasMultipleSlides,
                  bulletClass: "bullet-bg",
                  horizontalClass: "paginationXmas",
                }
              : false
          }
          modules={[Pagination]}>
          {groups.map((group: any) => (
            <SwiperSlide key={JSON.stringify(group)} className="!w-[calc(100%-50px)]">
              {group.map((item: any, idx) => (
                <div
                  key={idx}
                  className={
                    "flex items-center max-lg:w-full max-lg:my-2 first:max-lg:mt-0 last:max-lg:mb-0 px-2 lg:px-0 py-3 lg:pt-3 lg:pb-4 border-b border-black/8"
                  }>
                  <div className={"mr-3 rounded shrink-0"}>
                    <img
                      src={item.CompetitionThumbnailPicture}
                      alt={"Placeholder"}
                      width={48}
                      height={48}
                      className="object-cover size-11 rounded lg:size-14"
                    />
                  </div>
                  <div>
                    <div
                      className={`text-sm lg:text-base leading-5 lg:leading-5.5 font-medium mb-1 lg:mb-2 ${COLORS[item.NavigationColour as keyof typeof COLORS]?.title}`}>
                      {item.Title} {item.AdditionalCashText ? item.AdditionalCashText : null}
                    </div>
                    <div className={`flex gap-1 ${item.Reference.includes("DC") ? "items-start" : "items-center"}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        className={"size-5"}>
                        <path
                          d="M17.3333 4.78933V1.33333C17.3333 0.596667 16.7367 0 16 0H1.33333C0.596667 0 0 0.596667 0 1.33333V4.78933C0.775333 5.06467 1.33333 5.79733 1.33333 6.66667C1.33333 7.536 0.775333 8.26867 0 8.544V12C0 12.7367 0.596667 13.3333 1.33333 13.3333H16C16.7367 13.3333 17.3333 12.7367 17.3333 12V8.544C16.558 8.26867 16 7.536 16 6.66667C16 5.79733 16.558 5.06467 17.3333 4.78933ZM12.368 5.974L10.4333 7.414L11.152 9.716C11.2487 10.0247 10.898 10.2793 10.634 10.092L8.66667 8.69733L6.69933 10.092C6.43533 10.2793 6.08533 10.0247 6.18133 9.716L6.9 7.414L4.96533 5.974C4.706 5.78133 4.84 5.36933 5.16333 5.36533L7.57467 5.33733L8.34667 3.05267C8.45 2.74667 8.88333 2.74667 8.98667 3.05267L9.75867 5.33733L12.17 5.36533C12.4933 5.36867 12.6273 5.78067 12.368 5.974Z"
                          fill="#898994"
                        />
                      </svg>
                      <div className={"flex flex-col"}>
                        <div className={"text-xs leading-4 lg:text-sm lg:leading-5 font-medium"}>
                          <strong className={"text-dark-1"}>{setPointsByCompetitionType(item)}</strong> tickets
                        </div>
                        {item.Reference.includes("DC") && (
                          <div
                            className={
                              "text-[#898994] font-jost text-[10px] lg:text-xs leading-3 lg:leading-4 font-medium"
                            }>
                            + extra draw tickets for add-ons
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => onCompetitionClick(item)}
                    className={
                      "cursor-pointer uppercase bg-[#EEEEEF] ml-auto text-center px-2.5 py-1 rounded-lg text-nav-azure font-jost text-xs font-medium leading-normal min-h-8 lg:min-h-10 lg:min-w-20 flex-center lg:text-sm lg:leading-5"
                    }>
                    Enter
                  </div>
                </div>
              ))}
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }
  }
};

export default EarnPointsContent;
